import styled from "styled-components";

export const Wrapper = styled.div`
  background: #ffffff;
`;

export const Container = styled.div`
  .banner {
    width: 100%;
    display: block;
  }
  .list {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
    .item {
      flex: 1;
      height: 0.55rem;
      .child {
        height: 0.32rem;
        .text {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          p {
            font-size: 0.32rem;
            font-weight: 300;
            color: #999999;
          }
          span {
            font-size: 0.24rem;
            font-weight: 300;
            color: #999999;
            margin: 0 0 0 0.06rem;
          }
        }
      }
    }
    .item:nth-child(1) {
      width: 1.8rem;
      flex: none;
    }
    .item.active {
      .child {
        .text {
          p {
            font-size: 0.32rem;
            font-weight: 500;
            color: #FB7B00;
          }
          span {
            font-size: 0.24rem;
            font-weight: 500;
            color: #FB7B00;
          }
        }
      }
      .child::after {
        content: "";
        width: 1.08rem;
        height: 0.06rem;
        background: #FB7B00;
        border-radius: 0.06rem;
        display: block;
        margin: 0.18rem auto 0;
      }
    }
  }
  .title {
    height: 0.24rem;
    font-size: 0.24rem;
    font-weight: 300;
    color: #999999;
    line-height: 0.24rem;
    margin-top: 0.56rem;
    padding: 0 0.3rem;
  }
  .times {
    padding: 0 0.9rem 0 0.3rem;
    display: flex;
    align-items: center;
    height: 1rem;
    height: 1.1rem;
    .label {
      font-size: 0.28rem;
      font-weight: 400;
      color: #999999;
      margin-right: 0.34rem;
    }
    .picker {
      height: 0.7rem;
      background: #ffffff;
      box-shadow: 0px 0.02rem 0.16rem 0.02rem rgba(81, 78, 107, 0.1);
      border-radius: 0.05rem;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        height: 100% !important;
        min-height: 0 !important;
        width: 100% !important;
        .am-list-item,
        .am-list-item-middle {
          height: 100% !important;
          min-height: 0 !important;
          padding: 0;
          width: 100% !important;
        }
        .am-list-extra {
          flex: 1 !important;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.28rem;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
  .btns {
    margin-top: 0.6rem;
    padding: 0 0.3rem;
    .btn {
      width: 100%;
      height: 0.9rem;
      border: 1px solid #FB7B00;
      border-radius: 0.1rem;
      font-size: 0.32rem;
      font-weight: 400;
      color: #FB7B00;
      line-height: 0.9rem;
      text-align: center;
    }
  }
`;
